'use client';

// global-error.tsx must be a Client Component (Next.js requirement).
// Route segment config exports (dynamic, revalidate, etc.) are silently ignored
// in Client Components — do not add them here.
// The /_global-error prerender failure (digest 3209165217) is a pre-existing
// Next.js 16.2.10 + Turbopack framework bug unrelated to this file's contents.

export default function GlobalError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <body>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            width: '100%',
          }}
        >
          <div className="mb-3">
            <div>
              <div className="nothing-card-xl">
                <h4 className="h3">Uh oh, something went wrong</h4>
                <p className="p-3 text-center">
                  We are experiencing unexpected behavior. But we anticipate it won&apos;t be long.
                </p>
                <div className="nothing-action">
                  <button
                    type="button"
                    onClick={reset}
                    className="ls-button ls-button-secondary has-secondary"
                  >
                    Try Again
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      window.location.href = window.location.origin;
                    }}
                    className="ls-button ls-button-secondary has-secondary"
                  >
                    Go Home
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </body>
    </html>
  );
}
